// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__fiMCP","list":"PatternAutocomplete_list__21D2V"};